module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./node_modules/axios-es6/index.js
// module id = 113
// module chunks = 0 7 8 9 10 11 13 15 16